module.exports = __webpack_public_path__ + "static/img/erweima.4640345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/erweima.png
// module id = nbBo
// module chunks = 1